module.exports = __webpack_public_path__ + "img/cib.b8325cee.png";